import { Module } from 'vuex';

import { ListStatus, RootState, EditableStatus } from '@/store/types';
import Pagination from '@/store/models/pagination';

import { UsersState } from './types';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const getInitialState = (): UsersState => ({
  /**
   * List
   */
  listStatus: ListStatus.Loading,
  listPagination: new Pagination(),
  list: [],

  /**
   * Edit
   */
  editableStatus: EditableStatus.Loading,
  sendingWelcome: null,
});

const state = getInitialState();

const module: Module<UsersState, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};

export default module;
